<template>
<div class="indexPage" style="height: 100%;background:none;">

    <headfix></headfix>

    <div class="wraper-box" style="position: relative;">
        <div class="product-detail">
            <div class="left">
                <swiper :options="swiperOption" ref="swiperTop">
                     <swiper-slide class="prod_banner_item" v-for="(item,index) in articleInfo.thumbList">
                         <img :src="item" alt="" style="height: 530px;">
                     </swiper-slide>
                 </swiper>

                <swiper :options="swiperThumbOption" ref="swiperThumbs">
                     <swiper-slide class="prod_banner_item" v-for="(item,index) in articleInfo.thumbList">
                         <img :src="item" alt="" style="">
                     </swiper-slide>
                 </swiper>
            </div>
            <div class="right">

                <div class="r1">{{articleInfo.title}}</div>
                <div class="r2">
                    <div class="r21">规格</div>
                    <div class="r22">{{articleInfo.field1}}</div>
                </div>
                <div class="r2">
                    <div class="r21">颜色</div>
                    <div class="r22">{{articleInfo.field2}}</div>
                </div>
                <div class="r4">
                   <a href="javascript:;" class="buy">
                       <span>{{articleInfo.field3 != '' ? articleInfo.field3 : '立即购买'}}</span>

                      <div class="code">
                         <img :src="articleInfo.thumbCode" />
<!--                          <i>扫码查看场景手册</i>-->
                      </div>
                   </a>
<!--                   <a href="javascript:;" class="quest">在线咨询</a>-->
               </div>
            </div>
            <div class="clearfix"></div>
        </div>

        <div class="content" v-html="articleInfo.content"></div>


    </div>

    <footerfix></footerfix>


</div>
</template>
<script>
import headfix from '@/components/utils/headfix';
import footerfix from '@/components/utils/footerfix';
import {settingInfo_, categoryTree_, goCate_, goAdv_} from '@/components/js/app'
export default {
    components:{headfix, footerfix},
    data(){
        return{
            articleId:0,
            articleInfo:{},
            setting:{},
            advList:[],
            tabIndex:-1,
            currentId:0,

            swiperOption: {
                loop: true,
                loopedSlides: 3,
                spaceBetween: 10,
            },


            swiperThumbOption: {
                loop: true,
                        loopedSlides: 3,
                // centeredSlides: true,
                slidesPerView: 4,
                spaceBetween: 10,
                freeMode: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                slideToClickedSlide: true
            },

        }
    },
    created() {

        this.articleId = this.$route.query.id;
        this.$nextTick(()=>{

            this.getArticleInfoData(this.articleId);

        })
    },
    mounted() {
        document.querySelector('body').setAttribute('style', 'background-color:#faf9f5')
        this.$nextTick(()=>{
            const swiperTop = this.$refs.swiperTop.$swiper;
            const swiperThumbs = this.$refs.swiperThumbs.$swiper;

            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
        });

    },
    methods : {
        goCate_,
        goAdv_,
        getArticleInfoData (articleId) {

            this.$post_('api/cms-article/article-info-by-id', {id:articleId}, (res) => {
                if (res.code == 1) {
                    if (res.data) {
                        if (res.data.thumbList) {
                            res.data.thumbList = JSON.parse(res.data.thumbList)
                        }
                        this.articleInfo = res.data;
                    }

                } else {
                    this.$message.error(res.message);
                }
            })
        }
    }
}
</script>

<style scoped>
.product-detail{margin-top: 80px;display: flex;justify-content: space-between;}
.product-detail .left{width: 504px}
.product-detail .right{ padding-top:52px;flex: 1;margin-left: 60px;}
.product-detail .right .r1{font-size: 34px; line-height: 55px;font-weight: 600; }
.product-detail .right .r2{letter-spacing: 1px; display: block; margin: 25px 0px;}
.product-detail .right .r21{font-size: 16px;color: #000000;font-weight: 600;}
.product-detail .right .r22{font-size: 14px;color: #666666;}





.product-detail .right .r4{border-top: 1px solid #E6E6E6;display: flex;}
.product-detail .right .r4 a{text-align: center; border-radius:15px;margin-right:26px;padding: 6px 20px;color: #FFFFFF;margin-top: 30px;position:relative; }

.product-detail .right .r4 a .code{width: 120px;position: absolute;left: 50%;margin-left: -60px;text-align: center;top: 62px;transition: all 0.3s ease-in-out;opacity: 0;transform: translateY(20px);}
.product-detail .right .r4 a:hover .code{opacity: 1;transform: translateY(0);}
.product-detail .right .r4 a .code img{box-shadow: 0 0 15px rgb(0 0 0 / 10%);}
.product-detail .right .r4 a .code i{display: block;font-size: 14px;line-height: 30px;margin-top: 8px;font-style: normal;color: #333;}

.buy{background: #e66b28;}
.quest{background: #dcdcdc;}


/*产品中心-筛选*/

@media (max-width:1799px){

}
@media (max-width:1199px){

}
@media (max-width:993px){

    .product-detail{}
    .product-detail .left{width: 100%;}
    .product-detail .right{display: none;}
    .content{margin-top: 20px;padding: 10px;}


}

@media (max-width:767px){


}


</style>
